module.exports = __webpack_public_path__ + "img/primary_1x3_z18.d5830381.svg";